<div [ngClass]="containerClasses">

  @if (title) {
    <div
      class="input-title"
      [class.input-title--top]="filledField || isFocused"
      [class.input-title--focused]="isFocused"
      >
      <span>{{ title }}</span>
    </div>
  }

  <div class="input-wrapper">
    <ng-content></ng-content>
  </div>

  @if (error && errorMessage) {
    <div
      class="input-wrapper__error"
      role="alert"
      [attr.aria-label]="errorMessage"
      >
      {{ errorMessage }}
    </div>
  }

</div>